import styled from 'styled-components'
import { transparentize } from 'polished'
import theme from 'styled-theming'

import { COLORS, media, typeScale, THEME } from '../../styles'

const VARIANT = {
  color: theme('variant', {
    white: COLORS.white,
    blue: COLORS.white,
    black: COLORS.white,
    transparent: THEME.COLORS.foreground.primary,
  }),
  backgroundColor: theme('variant', {
    white: transparentize(0.8, COLORS.white),
    blue: COLORS.kale,
    black: COLORS.black,
    transparent: COLORS.transparent,
  }),
}
const DIRECTION = {
  direction: theme('direction', {
    horizontal: 'row nowrap',
    vertical: 'column nowrap',
  }),
  labelPadding: theme('direction', {
    horizontal: '0 0.8rem 0 0',
    vertical: '0.8rem 0 0 0',
  }),
  containerPadding: theme('direction', {
    horizontal: '0.4rem 0.8rem',
    vertical: '0',
  }),
  containerPaddingMedium: theme('direction', {
    horizontal: '0.8rem 1.2rem',
    vertical: '0',
  }),
  signalSize: theme('direction', {
    horizontal: '1rem',
    vertical: '1.6rem',
  }),
  labelOrder: theme('direction', {
    horizontal: 0,
    vertical: 1,
  }),
  signalOrder: theme('direction', {
    horizontal: 1,
    vertical: 0,
  }),
  signalBarWidth: theme('direction', {
    horizontal: '0.2rem',
    vertical: '0.3rem',
  }),
}
const Styled = styled.div``
Styled.container = styled.div`
  padding: ${DIRECTION.containerPadding};
  border-radius: 9999px;
  display: inline-flex;
  flex-flow: ${DIRECTION.direction};
  align-items: center;
  justify-content: center;
  background-color: ${VARIANT.backgroundColor};
  color: ${VARIANT.color};
  cursor: auto;
  ${media.medium`
    padding: ${DIRECTION.containerPaddingMedium};
  `}
`
Styled.label = styled.span`
  ${typeScale('caption')};
  padding: ${DIRECTION.labelPadding};
  color: ${VARIANT.color};
  user-select: none;
  order: ${DIRECTION.labelOrder};
`
Styled.signal = styled.div`
  width: ${DIRECTION.signalSize};
  height: ${DIRECTION.signalSize};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  order: ${DIRECTION.signalOrder};
`
Styled.signalBar = styled.div`
  width: ${DIRECTION.signalBarWidth};
  border-radius: 9999px;
  background-color: ${VARIANT.color};
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.4)};

  &:first-child {
    height: 33%;
  }

  &:nth-child(2) {
    height: 66%;
  }

  &:nth-child(3) {
    height: 100%;
  }
`

export default Styled
